export default "__VITE_ASSET__BwI6ag_i__"